<h1 mat-dialog-title *ngIf="title">
  <mat-icon *ngIf="icon" [innerHTML]="icon"></mat-icon>
  {{title}}
</h1>
<mat-dialog-content class="container-fluid container-lg">
  <hr *ngIf="title">
  <div class="row no-gutters">
    <div class="col-12">
      <p [innerHTML]="question"></p>
    </div>
  </div>

</mat-dialog-content>


<mat-dialog-actions>
  <button  type="button" mcButton variant="closedialog" mat-dialog-close>{{cancelButton}}</button>
  <button type="button"
          (click)="onConfirm()"
          mcButton variant="confirmdialog">{{confirmButton}}
  </button>
</mat-dialog-actions>



